module.exports = __webpack_public_path__ + "/hashedassets-launcher/v2/continue.fc3c949a123055af6fab4982957f51ea.svg";